import { render, staticRenderFns } from "./ShelveOrderModal.vue?vue&type=template&id=cd347338&scoped=true"
import script from "./ShelveOrderModal.vue?vue&type=script&lang=js"
export * from "./ShelveOrderModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cd347338",
  null
  
)

export default component.exports